export function isElementActuallyVisible(element, checkParents = false) {
	if (!element) return false;

	const rect = element.getBoundingClientRect();
	if (rect.width === 0 && rect.height === 0) return false;

	function nodeIsVisible(node) {
		const style = window.getComputedStyle(node);
		if (
			style.display === "none" ||
			style.visibility === "hidden" ||
			style.visibility === "collapse" ||
			parseFloat(style.opacity) <= 0 ||
			node.hidden
		) {
			return false;
		}
		return true;
	}

	let node = element;
	while (node && node.nodeType === 1) {
		const isVisible = nodeIsVisible(node)
		if (!checkParents) return isVisible
		if (!isVisible) return false
		node = node.parentElement;
	}
	return true;
}

export function observeNodeMutation(node, callback) {
	const mo = new MutationObserver((mutations) => {
		for (const m of mutations) {
			if (m.type === "attributes" && ["style", "class", "hidden"].includes(m.attributeName)) {
				callback?.();
				break;
			}
		}
	});
	mo.observe(node, { attributes: true, attributeFilter: ["style", "class", "hidden"] });
	return mo
}

export function parseMaxTime(durationStr) {
	if (!durationStr) return 0;
	return Math.max(
		...durationStr.split(",").map(s => {
			const v = s.trim();
			if (v.endsWith("ms")) return parseFloat(v);
			if (v.endsWith("s")) return parseFloat(v) * 1000;
			return parseFloat(v) || 0;
		})
	);
}

export function hasActiveCSSTransition(node, checkParents) {
	if (!node) return false;
	let n = node;
	while (n && n.nodeType === 1) {
		const style = window.getComputedStyle(n);
		const tDur = parseMaxTime(style.transitionDuration);
		const aDur = parseMaxTime(style.animationDuration);
		const tProp = style.transitionProperty;
		if ((tDur > 0 && tProp && tProp !== "none") || aDur > 0) return true;
		if (!checkParents) break;
		n = n.parentElement;
	}
	return false;
}